import { render, staticRenderFns } from "./GlobeIcon.vue?vue&type=template&id=c25de952"
import script from "./GlobeIcon.vue?vue&type=script&lang=ts"
export * from "./GlobeIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports